/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import { Formik } from 'formik';
import i18n from 'i18n';
import {
  authenticateMFARequest,
  authenticateRequest,
} from 'modules/authenticate/actions';
import { MfaData } from 'modules/authenticate/interfaces';
import { getOperatorRequest } from 'modules/operators/actions';
import { GetOperatorFields } from 'modules/operators/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import screenFields from './formSwitchRegionFields';
import styles from './styles';

const useStyles = makeStyles(styles);

const LOGGED_REGION_KEY = 'logged_region';

const initialValues = {
  password: '',
  mfa: '',
};
interface Props {
  isLoading: boolean;
  mfaChangeRegion: MfaData;
  operator_uuid: string;
  operatorDetails: GetOperatorFields | null;
  region: { name: string; code: string; url: string };
  authenticateMFARequest: (props: {
    code: string;
    callback?: (data: any) => void;
  }) => void;
  authenticateRequest: (props: {
    email: string;
    password: string;
    mfa_required: boolean;
    isChangeRegion: boolean;
    callback?: (data: any) => void;
  }) => void;
  getOperatorRequest: (id: string) => void;
  modalClose: () => void;
}

const FormSwitchRegion = ({
  isLoading,
  mfaChangeRegion,
  operator_uuid,
  operatorDetails,
  region,
  authenticateMFARequest,
  authenticateRequest,
  getOperatorRequest,
  modalClose,
}: Props) => {
  const classes = useStyles();
  const [step, setStep] = React.useState(1);

  const handleAuthenticate = values => {
    if (step === 1) {
      if (region) {
        localStorage.setItem(LOGGED_REGION_KEY, JSON.stringify(region));
      }

      authenticateRequest({
        email: operatorDetails?.email!,
        password: values.password,
        mfa_required: true,
        isChangeRegion: true,
        callback: data => {
          if (data.mfa.required) {
            setStep(2);
          } else {
            modalClose();
          }
        },
      });
    } else {
      authenticateMFARequest({
        code: values.code.replaceAll(' ', ''),
        callback: modalClose,
      });
    }
  };

  const copyToClipboard = (secret: string) => {
    navigator.clipboard.writeText(secret);
  };

  React.useEffect(() => {
    getOperatorRequest(operator_uuid);
  }, [getOperatorRequest, operator_uuid]);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleAuthenticate}
      enableReinitialize
    >
      {({ setFieldValue, errors, values }) => (
        <Grid item container xs={12} spacing={2}>
          {step === 1 && (
            <GenericForm
              values={values}
              screenFields={screenFields.slice(0, 1)}
              setFieldValue={setFieldValue}
              errors={errors}
            />
          )}
          {step === 2 && mfaChangeRegion.required && (
            <>
              {!mfaChangeRegion.configured && (
                <Grid item>
                  <figure className={classes.qrCodeWrapper}>
                    <img src={mfaChangeRegion.qrcode_url} alt="QR Code" />
                    <figcaption>{i18n.t('COPY_CLICK_HERE_KEY')}</figcaption>

                    {mfaChangeRegion?.secret && (
                      <button
                        className="qrCodeButton"
                        onClick={() => copyToClipboard(mfaChangeRegion.secret)}
                        data-copy-text={i18n.t('COPY_KEY')}
                        data-copied-text={i18n.t('COPIED_KEY')}
                      />
                    )}
                  </figure>
                </Grid>
              )}

              <GenericForm
                values={values}
                screenFields={screenFields.slice(1, 2)}
                setFieldValue={setFieldValue}
                errors={errors}
              />
            </>
          )}
          <Grid container justify="flex-end" className={classes.buttons}>
            <Button
              id="submit-button"
              disabled={isLoading}
              submitButton
              onClick={() => handleAuthenticate(values)}
            >
              {i18n.t('CONNECT_KEY')}
            </Button>
            <Button id="cancel-button" variant="outlined" onClick={modalClose}>
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        </Grid>
      )}
    </Formik>
  );
};

const mapStateToProps = ({
  authenticate: { data, mfaChangeRegion },
  operators: { operatorDetails, isLoading },
}: ApplicationState) => ({
  operator_uuid: data?.operator_uuid!,
  mfaChangeRegion,
  operatorDetails,
  isLoading,
});

export default connect(mapStateToProps, {
  authenticateRequest,
  getOperatorRequest,
  authenticateMFARequest,
})(FormSwitchRegion);
